import { CountCellProps } from '../../types';
import { formatNumberWithComma } from 'utils';

const SyncedCountsCell = ({ _customRowProps, synced }: CountCellProps) => {
  return <div>{formatNumberWithComma(synced)}</div>;
};

export default SyncedCountsCell;
